export interface CommonState {
  [key: string]: any,
};

const commonState: CommonState = {
  userRoles: null,
};

export default commonState;
